import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { BrowserRouter, Switch } from "react-router-dom";
import { getAuthorizationToken } from "../store/actions";
import Loading from "../components/templates/misc/loading/Loading";
const DefaultLayout = React.lazy(() => import("./layouts/DefaultLayout"));

const Navigator = () => {
  const loadingTemplate = () => (
    <div className="animated fadeIn pt-1 text-center">
      <Loading />
    </div>
  );
  const { loading } = useSelector((state) => state.userAction);
  const {
    tittleNotification,
    showNotification,
    typeNotification,
    contentNotification,
  } = useSelector((state) => state.notification);
  const dispatch = useDispatch();
// disabled auth
  // useEffect(async () => {
  //   dispatch(getAuthorizationToken());
  // }, []);

  const routes = (
    <Switch>
      <DefaultLayout
        loading={loading}
        tittleNotification={tittleNotification}
        showNotification={showNotification}
        typeNotification={typeNotification}
        contentNotification={contentNotification}
      />
    </Switch>
  );

  return (
    <React.Suspense fallback={loadingTemplate()}>
      <BrowserRouter>{routes}</BrowserRouter>
    </React.Suspense>
  );
};

export default Navigator;
